var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivedefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.29,
    height: 103.276,
    viewBox: "0 0 103.29 103.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "000000ff",
    transform: "translate(-30 274.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_efefefff",
    "data-name": "#efefefff",
    transform: "translate(27.02 -277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M12.4,3.55a24.849,24.849,0,0,1,6.67-.56c25.04.06,50.08-.06,75.12.05A12.6,12.6,0,0,1,106.2,15.01c.11,22.03.02,44.05.04,66.08.21,1.39-.73,2.48-1.5,3.51-4.43,5.66-8.6,11.53-13.01,17.21A10.729,10.729,0,0,1,83,106.26c-18.98-.03-37.97.02-56.95-.02a9.284,9.284,0,0,1-7.8-3.6C13.4,96.47,8.86,90.06,4.03,83.87c-1.24-1.32-1.02-3.22-1.05-4.88.07-21.03-.04-42.06.05-63.09A12.756,12.756,0,0,1,12.4,3.55M10.75,16.99V77.25q44.01,0,88-.01.015-27.66.01-55.32c-.05-2.93.32-6-.85-8.78-1.93-3.07-5.85-2.45-8.93-2.4q-33.96.045-67.92.01a43.418,43.418,0,0,0-7.03.23c-2.44.89-3.49,3.58-3.28,6.01m3.73,68.03c3.41,4.47,6.77,8.98,10.13,13.49q26.175-.03,52.35-.01c2.89-.06,6.04.51,8.62-1.14,3.04-4.15,6.15-8.24,9.23-12.35Q54.64,85.01,14.48,85.02Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M50.62,25.63c1.95-1.32,5.05-2.21,6.88-.22,4.63,4.07,9.48,7.91,14.17,11.92.78.84,1.97,1.52,2.2,2.73,1.36,3.16-3.34,6.41-5.8,4-3.26-2.55-6.33-5.32-9.56-7.9-.21,8.65.37,17.33-.32,25.96a4.545,4.545,0,0,1-7.12-.26c-.67-8.83-.17-17.72-.3-26.57-3.6,2.91-7.07,6-10.71,8.86-2.26,1.95-6.18-.21-5.91-3.11-.16-1.87,1.58-3.02,2.8-4.11C41.55,33.21,46,29.31,50.62,25.63Z",
    fill: "#efefef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedefault);
export default __webpack_public_path__ + "static/media/Archivedefault.1c03479676a1d0a7e74e345e250b6d8a.svg";
export { ForwardRef as ReactComponent };